import React, { useEffect ,memo, useRef} from "react";
import { sendCommand } from "../../support/LocalCommand";
import { getBlockRange, getSubscriptTrail, makeUniversalBlockKey, modelStore, remakeLineSizes } from "../storage/model";
import $ from "jquery"
import { Block } from "./EBlock";
import { createAndExecuteMetaChange, executeBlockContentChange, makeAndExecuteBlockLevelUpdate, makeBlockTextUpdate, makeRetypeBlockUpdate } from "../storage/changes";
import { access, logTimestamp, useProperty } from "../../support/general";
import { Col, Row, Stack } from "react-bootstrap";
import { copyRangeToClipboard, getBlocksFromClipboard } from "../storage/clipboard";
import { doChange, makeChange, undoChange } from "../storage/changes_admin";
import { doDefaultKeyHandling, insertTable, NoteTable } from "./ETable";

export const Page  = memo ( function ( { scriptId , subscriptId , pageIndex } ) { 

    // logTimestamp("run page - start "+ subscriptId)

    var blocks = [];
     
    var orderedIds = modelStore.useSelector(data=>{
        // logTimestamp("Page selector")
        return access(data,["model","Script",scriptId,"subscripts",subscriptId,"pages",pageIndex]);
    },scriptId+"_"+subscriptId+"_"+pageIndex);
    
    // var orderedIds =  access(modelStore.state,["model","Script",scriptId,"subscripts",subscriptId,"pages",pageIndex]);
    orderedIds = orderedIds?orderedIds:[];
    const Blocks = modelStore.access(["model","Block"]);

    $.each(orderedIds,(i,blockId)=>{
        const uid = makeUniversalBlockKey(scriptId,blockId);
        const block = Blocks[uid];
        if (block.type=="noteTable"){
            blocks.push(
                <NoteTable key={blockId} scriptId={scriptId} subscriptId={subscriptId} blockId={blockId} />
            )
        } else if (block.type.substring(0,5) != "table") {
            blocks.push(
                <Block key={blockId} scriptId={scriptId} blockId={blockId} />
            )
        }
    });

    var element = <div   
        style={{
        }}
    >    
        {blocks}
    </div>

    // logTimestamp("run page - end "+ subscriptId)

    return element;
});

export function ensureSubscriptLoaded(scriptId,subscriptId,onLoaded){
    var script = access(modelStore.state.model,["Script",scriptId]);
    var subscript = access(modelStore.state.model,["Script",scriptId,"subscripts",subscriptId]);
            
    if (subscript && !subscript.isLoaded){
       

            // no  need to dispatch - the dispatch will be executed when the server responds
            access(modelStore.state.model,["Script",scriptId,"subscripts",subscriptId]).isLoaded= true;
            sendCommand({
                actions : [{
                    objectType : 'Block',
                    verb : 'fetch',
                    scriptId : scriptId,
                    subscriptId : subscriptId
                }],
                onPostModelUpdate : (state)=>{
                    state.initializeSubscriptionBlockIdList(scriptId,subscriptId);
                    state.remakeNavTree(scriptId,subscriptId);
                    remakeLineSizes ( scriptId , subscriptId );
                    var loadedSubscript = access(modelStore.state.model,["Script",scriptId,"subscripts",subscriptId]);
                    if (loadedSubscript.type=="directory" ){
                        if ( !loadedSubscript.columns || loadedSubscript.columns.length==0 ) {                  
                            loadedSubscript.columns = [
                                {
                                    fieldId : '-entryName',
                                    width : 100,
                                }
                            ]
                        }
                    }
                },
                onSucceeded : onLoaded
            });     
        
        
    } else {
        if (onLoaded){
            onLoaded();
        }
    }

}

export function PagedSubscript({scriptId,subscriptId,blockTypes,blockContinuationRules,font,blankEnterForBlockType}){

    // logTimestamp("run PagedSubscript - start "+ subscriptId )

    var eleRef = useRef();

    var reviewLinesTimeoutRef = useRef(null);

    var pages = [];
    var [getTypePopupVisible,setTypePopupVisible] = useProperty(null);

    useEffect(()=>{
        //ensureSubscriptLoaded( scriptId , subscriptId );  
        return ()=>{
            clearLinesTimeout();
        } 
    },[]);
 
    function clearLinesTimeout (){
        if (reviewLinesTimeoutRef.current){
            clearTimeout(reviewLinesTimeoutRef.current);
            reviewLinesTimeoutRef.current = null;
        }
    }

    function manageLineSizes(){
        clearLinesTimeout();
        reviewLinesTimeoutRef.current = setTimeout(()=>{
            modelStore.dispatch(state=>{
                remakeLineSizes(scriptId,subscriptId);
            })
        },2000);
    }
       
    modelStore.useSelector( state => { 
        // logTimestamp("PagedSubscript selector : subscriptId = "+ subscriptId)
        return access(state,['model','Script',scriptId,'subscripts',subscriptId,'pages']);
    },scriptId+"_"+subscriptId);
    
    var pageList = modelStore.access(['model','Script',scriptId,'subscripts',subscriptId,'pages']);

    pageList = pageList??[];

    $.each(pageList,(pageIndex,page)=>{
        pages.push(
            <Page key={pageIndex.toString()} scriptId={scriptId} subscriptId={subscriptId} pageIndex={pageIndex} />
        )
    });

    function requestTypePopupClose(){

        var target = getTypePopupVisible();
        setTypePopupVisible(null);
        $(eleRef.current).focus();
        
    }

    function showBlockType(){
        const {
            selection,
            basePosition,
            endPosition
        }= getSelection(scriptId,subscriptId);

        var rangeBefore = makeRange(scriptId,subscriptId,selection);
        
        var blockLocations = [];
        for(var i=basePosition;i<=endPosition;i++){
            blockLocations.push(i);
        } 

        setTypePopupVisible({
            blockLocations,
            rangeBefore
        });
        
    }

    
    function onKeyDown(event){

        // logTimestamp("key down")
        // console.log(event.key);

        if (event.isComposing){
            return;
        }
        if (
            (event.key.substring(0,5)=='Arrow') ||
            (event.key.substring(0,4)=='Page') ||
            (event.key=='Home') ||
            (event.key=='End')
        )    {
            return;
        }

        var key = event.key;
        var qualifiers = (event.altKey?"a":"-") + (event.ctrlKey?"c":"-") + (event.metaKey?"m":"-")  + (event.shiftKey?"s":"-");

        if (key.length==1){
            if (qualifiers.indexOf("s")==-1) {
                key = key.toLowerCase();
            } if (qualifiers.indexOf("s")!=-1) {
                key = key.toUpperCase();
            }
        }
        if ( key=='z' && qualifiers=='-c--') {
            undoChange(scriptId,subscriptId);
        } else if (key.length==1 && ((qualifiers == "----") || (qualifiers == "---s")) ){ 
            // simple character to be inserted into the text
            var targetBlock = insertLetter(scriptId,subscriptId,key);
        } else if (qualifiers=='a---' && key=="t" ) {
            insertNoteTable(scriptId,subscriptId);
        } else if (qualifiers=='a---') {
            var blockType = blockTypes.find(t=>t.key==key);
            if (blockType){
                changeBlockType (scriptId,subscriptId,blockType.type);
            }
        } else if (key=="Enter" ) {
            var result = insertEnter(scriptId,subscriptId,blockContinuationRules,blankEnterForBlockType);
            if (result == "typePopup"){
                showBlockType();
            }
        } else if (key=="Tab" ) {
            var result = insertTab(scriptId,subscriptId);
            if (result == "typePopup"){
                showBlockType();
            }

        } else  if ( key=='[' && ( qualifiers=='a---' || qualifiers=='-c--' || qualifiers=='--m-'  ) ) {
            indentBlocks (scriptId,subscriptId,-1)
        } else  if ( key==']' &&  ( qualifiers=='a---' || qualifiers=='-c--' || qualifiers=='--m-'  ) ) {
            indentBlocks (scriptId,subscriptId,1)
        } else if (key=="Delete" ) {
            doDeletion(scriptId,subscriptId);
        } else if (key=="Backspace") {
            doBackspace(scriptId,subscriptId);
        } else if (qualifiers == "--m-"){
            // do nothing but don't return
        } else {
            return
        }
            
                       
        
        
        manageLineSizes()
        
        event.preventDefault();
    }

    var typePopup = null;
    if (!!getTypePopupVisible()){
        typePopup = <TypePopup 
            scriptId ={scriptId}
            subscriptId ={subscriptId}
            target = {getTypePopupVisible()}
            blockTypes = {blockTypes}
            requestClose = {requestTypePopupClose}
        />
    }

    function onInput(e){
        var nativeEvent = e.nativeEvent;
        if (nativeEvent.inputType == 'insertReplacementText'){

            var selection = getBlockSelection();
            if (selection.blocks.length==1){
                var baseBlock = selection.blocks[0];

                var newText = $('.'+makeUniversalBlockKey(scriptId,baseBlock.id)+"_inner").text()

                executeBlockContentChange(scriptId,subscriptId,baseBlock.id,{t:true},{text:newText})
            }

        }
    }
    // https://stackoverflow.com/questions/3300660/how-do-i-center-an-image-if-its-wider-than-its-container
    var element = <Col
            onInput = {onInput}

        contentEditable = "true"
        suppressContentEditableWarning={true}
        onKeyDown = {onKeyDown}
        className=" noScrollBar"
        style={{
            font: font, //'18px Courier, fixed',
            height : '100%',
            overflowY : 'auto'
        }}
        onCopy = {(e)=>{e.preventDefault() ;doCopy(scriptId,subscriptId);}}
        onPaste = {(e)=>{e.preventDefault() ;doPaste(scriptId,subscriptId);manageLineSizes();}}
        onCut = {(e)=>{e.preventDefault() ;doCut(scriptId,subscriptId);manageLineSizes();}}
        ref = {eleRef}
    >
        {typePopup}
        <div 
            style={{
                width:'100ex',
                marginLeft: 'auto',
                marginRight: 'auto',
            }} 
        > 
            {pages}
        </div>
        <SelectionTrigger />
    </Col>
   
    // logTimestamp("run PagedSubscript - end "+ subscriptId)
    return element;

}

export function TypePopup({scriptId,subscriptId,blockTypes,target,requestClose}){

    var eleRef = useRef();

    useEffect(()=>{
        $(eleRef.current).focus();
    })

    function onKeyDown(e){

        const {
            handled,
            key,
            qualifiers
        } = doDefaultKeyHandling(e,scriptId,subscriptId);

        
        if ( (key=="Escape") || (key=="Tab") ) {
            e.stopPropagation();
            e.preventDefault();
            requestClose();
        }

        var availableTypes = {}
        $.each(blockTypes,(i,type)=>{
            availableTypes[type.key] = type.type 
        });
        var newType = availableTypes[key];
        
        if (newType){
            changeBlockType(scriptId,subscriptId,newType);
            requestClose();
        }
        e.stopPropagation();
        e.preventDefault();
    }
// 

    // var cmdElements = $.map([
    //     {key:'c',name:'Character',type:'character'},
    //     {key:'d',name:'Dialog',type:'dialog'},
    //     {key:'s',name:'Scene Heading',type:'scene'},
    //     {key:'h',name:'Shot',type:'shot'},
    //     {key:'e',name:'Section',type:'section'},
    //     {key:'q',name:'Sequence',type:'sequence'},
    //     {key:'n',name:'Note',type:'note'},
    //     {key:'a',name:'Action',type:'action'},
    //     {key:'t',name:'Transition',type:'transition'},
    //     {key:'p',name:'Parenthetical',type:'parenthetical'},
    // ],(ccc,c)=>{

    var cmdElements = $.map(blockTypes,(ccc,c)=>{
        return (<div
            style = {{
                // pointerEvents: 'none',
                cursor : 'pointer'
            }}
            key = {ccc.key}
            onClick = {(e)=>{onCmd(ccc.type);e.stopPropagation();}}
        >   
            {"("+ccc.key+") "+ccc.name}
        </div>)
    });

    function onCmd(newBlockType){
        changeBlockType (scriptId,subscriptId,newBlockType,target.blockLocations,target.rangeBefore)
        requestClose();
    }

    function onFocus(){
        console.log("typePopup focussed");
    }
    function onBlur(){
        console.log("typePopup blurred");        
    }
    return (<div
        id = "typePopup"
        contenteditable="false"
        style = {{
            display : 'block',
            position : 'fixed',
            top :0,
            left :0,
            width : '100%',
            height : '100%',
        }}
        tabindex = {0}
        key ="1"
        ref = {eleRef}
        onKeyDown = {onKeyDown}
        onClick={(e)=>{requestClose();}}
        onFocus = {onFocus}
        onBlur = {onBlur}
        autoFocus
    >
        <div
            style = {{
                padding : '1em',
                border : '1px solid',
                // backgroundColor :'red',
                position: 'absolute',
                top:  '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                backgroundColor:'white',
                textAlign : 'left',
            }}
            key ="2"
        >
           {cmdElements}
        </div>

    </div>  )
}

function SelectionTrigger(){
    
    modelStore.useSelector((state)=>{
        return state.selectionTrigger;
    });

    useEffect( ()=>{
        var selection = modelStore.state.selectionTrigger;
        
        if (selection){
            
                // console.log ("selection range");

                var scriptId = selection.scriptId;
                var subscriptId = selection.subscriptId;

                var startBlock = modelStore.state.getBlock(scriptId,subscriptId,selection.fromLocation);
                var endBlock = modelStore.state.getBlock(scriptId,subscriptId,selection.toLocation);

                // console.log("Cursor at : "+startBlock.id);
                
                var range = document.createRange();
                try {
                var settableNode = $('#'+makeUniversalBlockKey(scriptId,startBlock.id)).get(0).childNodes[0];
                settableNode=(settableNode.childNodes[0])?settableNode.childNodes[0]:settableNode;
                range.setStart( settableNode, selection.fromOffset);

                    var endNode = $('#'+makeUniversalBlockKey(scriptId,endBlock.id)).get(0).childNodes[0];
                    endNode=(endNode.childNodes[0])?endNode.childNodes[0]:endNode;
                    
                    range.setEnd( endNode, selection.toOffset);

                    var sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                } catch (e) {
                    console.log ( "Threw error applying cursor selection " + e );
                }
           

        }
        
        },[modelStore.state.selectionTrigger]
    );

    return <div></div>
}

/*
    UPDATE 
    sizeOfDeletion - 0 means no deletion - other wise number of blocks affected by the deletion

    targetAt  - insertion point
    targetOffset - negative means in the gap before the target block        
    deletionEndOffset - negative means whole block goes 

    leadInsertionText - into the target block or at end of the target block if there are block to be inserted 
    insertionBlocks -  list of block descriptions - inserted after the target block
    trailingText 
*/

function doCopy(scriptId,subscriptId){

    var selection = getBlockSelection();
    var baseBlock = selection.blocks[0];
    var basePosition = modelStore.state.getBlockPosition( scriptId,subscriptId,baseBlock.id );
    var endBlock = selection.blocks[selection.blocks.length-1];
    var endPosition = modelStore.state.getBlockPosition( scriptId,subscriptId,endBlock.id );

    copyRangeToClipboard({
        scriptId,
        subscriptId,
        sizeOfCopy : Math.max(0,selection.blocks.length),
        targetAt : basePosition,
        targetOffset : selection.fromOffset,
        copyEndOffset : selection.toOffset,
    });

}

function doCut(scriptId,subscriptId){
    doCopy(scriptId,subscriptId);
    doDeletion(scriptId,subscriptId);
}

function  doDeletion(scriptId,subscriptId){
    var selection = getBlockSelection();
    var baseBlock = selection.blocks[0];
    var basePosition = modelStore.state.getBlockPosition( scriptId,subscriptId,baseBlock.id );
    var endBlock = selection.blocks[selection.blocks.length-1];
    var endPosition = modelStore.state.getBlockPosition( scriptId,subscriptId,endBlock.id );

    var update = null;
    var rangeBefore = makeRange(scriptId,subscriptId,selection);

    if ( baseBlock.id != endBlock.id || selection.fromOffset!=selection.toOffset){
        var update = makeBlockTextUpdate({
            sizeOfDeletion : Math.max(0,selection.blocks.length-1),
            targetAt : basePosition,
            targetOffset : selection.fromOffset,
            deletionEndOffset : selection.toOffset,

            leadInsertionText : "",
            insertionBlocks : [],
            trailingText : ""
        });

    } else {
        
        if (selection.fromOffset == baseBlock.text.length){
            var subscriptBlockIds = modelStore.state.getSubscriptOrderedBlockIds(scriptId,subscriptId);
            if (basePosition<subscriptBlockIds.length){
                 var update = makeBlockTextUpdate({
                    sizeOfDeletion : 1,
                    targetAt : basePosition,
                    targetOffset : selection.fromOffset,
                    deletionEndOffset : 0,

                    leadInsertionText : "",
                    insertionBlocks : [],
                    trailingText : ""

                })
            }
        } else if ( baseBlock.text.length ) {
             var update = makeBlockTextUpdate({
                sizeOfDeletion : 0,
                targetAt : basePosition,
                targetOffset : selection.fromOffset,
                deletionEndOffset : selection.toOffset+1,

                leadInsertionText : "",
                insertionBlocks : [],
                trailingText : ""

            });
        }
        
    }

    if (update) {
        var change = makeChange(scriptId,subscriptId,update,rangeBefore);
        doChange(change);
    }
}

function  doBackspace(scriptId,subscriptId){
 var selection = getBlockSelection();
    var baseBlock = selection.blocks[0];
    var basePosition = modelStore.state.getBlockPosition( scriptId,subscriptId,baseBlock.id );
    var endBlock = selection.blocks[selection.blocks.length-1];
    var endPosition = modelStore.state.getBlockPosition( scriptId,subscriptId,endBlock.id );

    var update = null;
    var rangeBefore = makeRange(scriptId,subscriptId,selection);

    if ( baseBlock.id != endBlock.id || selection.fromOffset!=selection.toOffset){

         var update = makeBlockTextUpdate({
            sizeOfDeletion : Math.max(0,selection.blocks.length-1),
            targetAt : basePosition,
            targetOffset : selection.fromOffset,
            deletionEndOffset : selection.toOffset,

            leadInsertionText : "",
            insertionBlocks : [],
            trailingText : ""

        });

    } else {
        if (selection.fromOffset == 0){
            if (basePosition>0){
                var prevPosition = basePosition-1;
                var prevBlock = modelStore.state.getBlock(scriptId,subscriptId,prevPosition)
                var update = makeBlockTextUpdate({
                    sizeOfDeletion : 1,
                    targetAt : prevPosition,
                    targetOffset : prevBlock.text.length,
                    deletionEndOffset : 0,

                    leadInsertionText : "",
                    insertionBlocks : [],
                    trailingText : ""

                });
            }
        } else {
            var update = makeBlockTextUpdate({
                sizeOfDeletion : 0,
                targetAt : basePosition,
                targetOffset : selection.fromOffset-1,
                deletionEndOffset : selection.toOffset,

                leadInsertionText : "",
                insertionBlocks : [],
                trailingText : ""

            });
        }
    }

    if (update) {
        var change = makeChange(scriptId,subscriptId,update,rangeBefore);
        doChange(change);
    }
}
function makeRange(scriptId, subscriptId,selection){
    var baseBlock = selection.blocks[0];
    var endBlock = selection.blocks[selection.blocks.length-1];
    return {
        scriptId : scriptId,
        subscriptId : subscriptId,
        fromLocation : modelStore.state.getBlockPosition( scriptId,subscriptId,baseBlock.id ),
        fromOffset : selection.fromOffset,
        toLocation : modelStore.state.getBlockPosition( scriptId,subscriptId,endBlock.id ),
        toOffset : selection.toOffset,
    };
}

function getSelection(scriptId,subscriptId){
    
    var selection = getBlockSelection();
    var baseBlock = selection.blocks.length?selection.blocks[0]:null;;
    var basePosition = selection.blocks.length?modelStore.state.getBlockPosition( scriptId,subscriptId,baseBlock.id ):-1;
    var endBlock = selection.blocks.length?selection.blocks[selection.blocks.length-1]:null;
    var endPosition = selection.blocks.length?modelStore.state.getBlockPosition( scriptId,subscriptId,endBlock.id ):-1;

    return {
        selection,
        baseBlock,
        basePosition,
        endBlock,
        endPosition
    }
}
function insertLetter(scriptId,subscriptId,key){

    var selection = getBlockSelection();
    var baseBlock = selection.blocks[0];
    var basePosition = modelStore.state.getBlockPosition( scriptId,subscriptId,baseBlock.id );
    var endBlock = selection.blocks[selection.blocks.length-1];
    var endPosition = modelStore.state.getBlockPosition( scriptId,subscriptId,endBlock.id );

    var rangeBefore = makeRange(scriptId,subscriptId,selection);

    var update = makeBlockTextUpdate({
        sizeOfDeletion : Math.max(0,selection.blocks.length-1),
        targetAt : basePosition,
        targetOffset : selection.fromOffset,
        deletionEndOffset : selection.toOffset,

        leadInsertionText : "",
        insertionBlocks : [{type:'text',text:key}],
        trailingText : ""

    });

    var change = makeChange(scriptId,subscriptId,update,rangeBefore);
    doChange(change);
    
    return access (modelStore.state,["model","Block",makeUniversalBlockKey(scriptId,baseBlock.id)]);

}

function indentBlocks (scriptId,subscriptId,delta){
        
    var {
        basePosition,
        endPosition
    } = getSelection(scriptId,subscriptId);

    var newValues = [];

    var blocks = getBlockRange(scriptId,subscriptId,basePosition,(endPosition-basePosition)+1);

    $.each(blocks,(b,block)=>{
        var indent = block.meta.indent;
        newValues.push(Math.max(0,(indent?indent:0)+delta));
    })

    createAndExecuteMetaChange(scriptId,subscriptId,basePosition,"indent",newValues);

}


function changeBlockType (scriptId,subscriptId,newBlockType,blockPositions,rangeBefore){
    
    var {
        selection,
        basePosition,
        endPosition
    } = getSelection(scriptId,subscriptId);

    if (!blockPositions){
        blockPositions = [];
        for (var i=basePosition;i<=endPosition;i++){
            blockPositions.push(i);
        }
    }

    if (!rangeBefore){
        rangeBefore = makeRange(scriptId,subscriptId,selection);
    }

    var update = makeRetypeBlockUpdate({
        blockPositions : blockPositions,
        newBlockType : newBlockType
    });
    var change = makeChange(scriptId,subscriptId,update,rangeBefore);
    doChange(change);

}

function insertTab(scriptId,subscriptId){
    
    var selection = getBlockSelection();
    var baseBlock = selection.blocks[0];

    var rangeBefore = makeRange(scriptId,subscriptId,selection);
    if (baseBlock.type=='action' && baseBlock.text==""){
        changeBlockType(scriptId,subscriptId,'character');
    } else {
        return "typePopup";
    }
}

function doPaste(scriptId,subscriptId){

    var selection = getBlockSelection();
    var baseBlock = selection.blocks[0];
    var basePosition = modelStore.state.getBlockPosition( scriptId,subscriptId,baseBlock.id );
    var endBlock = selection.blocks[selection.blocks.length-1];
    var endPosition = modelStore.state.getBlockPosition( scriptId,subscriptId,endBlock.id );

    getBlocksFromClipboard(blocks=>{
        if (blocks?.length){

            // the text from the first block is treated as plain text and added to the text of the block being inserted into.

            var rangeBefore = makeRange(scriptId,subscriptId,selection);

            // var leadBlock = blocks.splice(0,1);
            // var leadInsertionText = leadBlock[0].text;

            var update = makeBlockTextUpdate({
                sizeOfDeletion : Math.max(0,selection.blocks.length-1),
                targetAt : basePosition,
                targetOffset : selection.fromOffset,
                deletionEndOffset : selection.toOffset,

                leadInsertionText : "",
                insertionBlocks : blocks,
                trailingText : "",

            });

            var change = makeChange(scriptId,subscriptId,update,rangeBefore);
            doChange(change);
        }
    });


}

function insertNoteTable(scriptId,subscriptId){
    var selection = getBlockSelection();
    var baseBlock = selection.blocks[0];
    var basePosition = modelStore.state.getBlockPosition( scriptId,subscriptId,baseBlock.id );

    insertTable(scriptId,subscriptId,basePosition);
    
}

function insertEnter(scriptId,subscriptId,blockContinuationRules,blankEnterForBlockType){

    var selection = getBlockSelection();
    var baseBlock = selection.blocks[0];
    var basePosition = modelStore.state.getBlockPosition( scriptId,subscriptId,baseBlock.id );
    var endBlock = selection.blocks[selection.blocks.length-1];
    var endPosition = modelStore.state.getBlockPosition( scriptId,subscriptId,endBlock.id );
    
    var rangeBefore = makeRange(scriptId,subscriptId,selection);

    if (selection.isNotRange && baseBlock.text=="" && blankEnterForBlockType){
        return "typePopup";
    } else {
        var update = makeBlockTextUpdate({
            sizeOfDeletion : Math.max(0,selection.blocks.length-1),
            targetAt : basePosition,
            targetOffset : selection.fromOffset,
            deletionEndOffset : selection.toOffset,
            enter : true,
            blockContinuationRules : blockContinuationRules

        });
        var change = makeChange(scriptId,subscriptId,update,rangeBefore);
        doChange(change);
    }
    

}

function getBlockPositionAndDmlOffset(node,offset){

    node = getNodeIdParent(node);

    const bits = node.id.split("_");
    const blockUid = bits [1];
    const block = modelStore.state.model.Block[blockUid];
    const scriptId = block.scriptId;
    const subscriptId = block.subscriptId;

    var blockPosition = modelStore.state.getBlockPosition(scriptId,subscriptId,bits[1]);
    var dmlOffset = bits.slice(2);
    dmlOffset.push(offset);

    return [blockPosition,dmlOffset];

}

function getDmlBlockSelection(selection){

    var toPosition = 0;
    var toDmlOffset = 0;

    const[fromPosition,fromDmlOffset] = getBlockPositionAndDmlOffset(selection.anchorNode,selection.anchorOffset);
    
    if (selection.type=='Range'){
        const[blockPosition,dmlOffset] = getBlockPositionAndDmlOffset(selection.focusNode,selection.focusOffset);
        toPosition = blockPosition;
        toDmlOffset = dmlOffset;
    } else {
        toPosition = fromPosition;
        toDmlOffset = fromDmlOffset;
    }

    if (toPosition<fromPosition){
        var temp = toDmlOffset;toDmlOffset=fromDmlOffset;fromDmlOffset = temp;
        temp = toPosition;toPosition=fromPosition;fromPosition = temp;
    }

    return {
        blocks :  [],
        fromOffset : 0,
        toOffset : 0,
        isNotRange : false,
        fromDmlOffset,
        toDmlOffset,
        isDml : true,

    }
    
} 

export function getBlockSelection(){
    const selection = window.getSelection();

    var fromNode = getNodeIdParent(selection.anchorNode);

    if (fromNode && fromNode.id.substring(0,4)=="dml_"){
        return getDmlBlockSelection(selection);
    } else {
        var fromBlock = nodeToBlock(selection.anchorNode);
        if (fromBlock){

            var fromOffset = selection.anchorOffset;
            var toBlock = nodeToBlock(selection.focusNode);
            var toOffset = selection.focusOffset;
            var scriptId = fromBlock.scriptId;
            var subscriptId = fromBlock.subscriptId;

            if (selection.type=='Range') {

                var fromPosition = modelStore.state.getBlockPosition(scriptId,subscriptId,fromBlock.id);
                var toPosition = toBlock?modelStore.state.getBlockPosition(scriptId,subscriptId,toBlock.id):fromPosition;
                if (fromPosition == toPosition){
                    if (toOffset<fromOffset){
                        var temp = fromOffset;
                        fromOffset = toOffset;
                        toOffset = temp;
                    }
                    return {
                        blocks :  [fromBlock],
                        fromOffset : fromOffset,
                        toOffset : toOffset,
                        isNotRange : toOffset==fromOffset,
                    }
                } else {
                    if (toPosition<fromPosition){
                        var temp = toBlock;toBlock=fromBlock;fromBlock = temp;
                        temp = toOffset;toOffset=fromOffset;fromOffset = temp;
                        temp = toPosition;toPosition=fromPosition;fromPosition = temp;
                    }
                    return {
                        blocks :  modelStore.state.getBlocksFromPosition(scriptId,subscriptId,fromPosition,(toPosition-fromPosition)+1),
                        fromOffset : fromOffset,
                        toOffset : toOffset,
                        isNotRange : false,
                        fromDmlOffset : [],
                        toDmlOffset : [],
                        isDml : false,

                    }
                }
            } else {
                return {
                    blocks : [fromBlock],
                    fromOffset : fromOffset,
                    toOffset : fromOffset,
                    isNotRange : true,
                    isDml : false,
                    fromDmlOffset : [],
                    toDmlOffset : [],
                }
            }
        
        } else {
            return {
                blocks : [],
                fromOffset : 0,
                toOffset : 0,
                isNotRange : true,
                fromDmlOffset : [],
                toDmlOffset : [],
                isDml : false,   
            }
        }
    }
    
}


export function getNodeIdParent(node){
    var block = null;
    while (node && !node.id){
        node = node.parentNode;
    }
    return node;
}

function nodeToBlock(node){
    var block = null;
    node = getNodeIdParent (node);
    if (node){
        var blockUid = node.id;
        block = modelStore.state.model.Block[blockUid];
    }
    return block;
}



